<div class="col-xs-12" ng-show="resumo" id="resumo">
  <div class="ibox float-e-margins">
    <div class="ibox-title">Resumo</div>
    <div class="ibox-content">
      <div class="row">
        <div class="col-xs-6">
          <h3 ng-show="resumo.total_atrasados" class="text-danger text-light no-margin">
            Total em atraso: <strong>{{resumo.total_atrasados}}</strong><br>
          </h3>

          <h3 ng-show="resumo.total_checagens_atrasadas" class="text-danger text-light no-margin">
            Total checagens em atraso: <strong>{{resumo.total_checagens_atrasadas}}</strong>
          </h3>

          <h3 class="text-light">Total registros: <strong>{{resumo.total_registros}}</strong></h3>
        </div>
        <div class="col-xs-6" ng-hide="filters.maquina.id">
          Seleciona uma máquina para ver detalhes!
        </div>
        <div class="col-xs-6" ng-show="filters.maquina.id">
          <p class="text-light">Máquina: <strong>{{filters.maquina.descricao}}</strong></p>
          <p class="text-light">Ano fabricação: <strong>{{filters.maquina.ano_fabricacao}}</strong></p>
          <p class="text-light">Ano aquisição: <strong>{{filters.maquina.ano_compra || 'Não informado'}}</strong></p>
          <p ng-show="resumo.maquina.id == filters.maquina.id" class="text-light">
            {{tiposControleMaquina[filters.maquina.tipo_controle_manutencao] || ''}}:
            <strong>{{resumo.maquina.horimetro_atual | number}}</strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="col-xs-12" ng-show="ocorrencias">
  <div class="ibox float-e-margins">
    <div class="ibox-title">Resultados</div>
    <div class="ibox-content">
      <small ng-show="ocorrencias.length == 0">Nenhum resultado encontrado!</small>
      <table class="table table-hover table-striped" ng-show="ocorrencias.length > 0">
        <thead>
          <tr>
            <th>Código</th>
            <th class="text-center">Data</th>
            <th class="text-center">Prazo</th>
            <th>Máquina</th>
            <th>Tipo</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="ocorrencia in ocorrencias track by $index">
            <td class="vertical-middle">{{::ocorrencia.id}}</td>
            <td class="vertical-middle text-center">{{::ocorrencia.data | date:'dd/MM/yyyy'}}</td>
            <td class="vertical-middle text-center">{{::ocorrencia.data_prazo | date:'dd/MM/yyyy'}}</td>
            <td class="vertical-middle">{{::ocorrencia.maquina.descricao}}</td>
            <td class="vertical-middle">{{::ocorrencia.tipo.descricao}}</td>
            <td class="vertical-middle text-right">
              <span class="label label-default">{{::ocorrencia.status.descricao | capitalize}}</span>
              <span class="label label-danger" ng-show="ocorrencia.foraDoPrazo">Em atraso</span>
              <span class="label label-danger" ng-show="ocorrencia.foraDoPrazoDeChecagem">Checagem em atraso</span>
            </td>
            <td class="vertical-middle text-right">
              <div class="btn btn-primary btn-sm" ng-click="check($index)" ng-if="permissions.maquina.canCheck && isClosedStatus($index)"
                   uib-tooltip="Checar ocorrência" tooltip-placement="top">
                <i class="glyphicon glyphicon-check"></i>
              </div>
              <div class="btn btn-primary btn-sm" ng-click="addClose($index)" ng-if="permissions.maquina.canManage && isOpenedStatus($index)"
                   uib-tooltip="Fechar Ocorrência" tooltip-placement="top">
                <i class="glyphicon glyphicon-minus"></i>
              </div>
              <div class="btn btn-primary btn-sm" ng-click="addComment($index)" ng-if="permissions.maquina.canManage"
                   uib-tooltip="Adicionar Comentário" tooltip-placement="top">
                <i class="glyphicon glyphicon-comment"></i>
              </div>
              <div class="btn btn-primary btn-sm" ng-click="showOcorrencia($index)" uib-tooltip="Visualizar" tooltip-placement="top">
                <i class="glyphicon glyphicon-eye-open"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-right">
        <ng-include src="'views/_pagination.html'"></ng-include>
      </div>
    </div>
  </div>
</div>
